import { createFileRoute } from '@tanstack/react-router';
import { TypeEditorPage } from '../../types/TypeEditorPage.js';

export const Route = createFileRoute('/types/$typeKey')({ component: TypeEditorRoute });

function TypeEditorRoute(): React.JSX.Element {
  const { typeKey } = Route.useParams();
  return <TypeEditorPage typeKey={typeKey} />;
}
